<form [formGroup]="formGroup" class="d-flex flex-lg-row flex-column gap-2 px-3">
  <div class="input-group">
    <div class=" col-lg-12">
      <ncp-radios [(options)]="medicationRadiosOptions" />
    </div>
    <div class="col-12">
      @switch(medicationRadiosOptions().value) {
        @case (0) {
          <ncp-input #searchInput [(options)]='brandNameInputOptions' />
        }
        @case (1) {
          <ncp-input #searchInput [(options)]='activeSubstanceInputOptions' />
        }
        @case (2) {
          <ncp-input #searchInput [(options)]='atcCodeInputOptions' />
        }
        @default {
          show nothing
        }
      }
    </div>
  </div>
</form>
